import Icons from '@/constants/Icons';
import RouteNames from '@/constants/RouteNames';
import type { AppRouteRecord } from '@/types/core';

export const foremanCreateRoute: AppRouteRecord = {
  component: () => import('@/views/foreman/ForemanForm.vue'),
  name: RouteNames.Foreman.Create,
  path: 'create',
};

export const foremanEditRoute: AppRouteRecord = {
  component: () => import('@/views/foreman/ForemanForm.vue'),
  name: RouteNames.Foreman.Edit,
  path: ':foremanUid/edit',
};

export const foremanListRoute: AppRouteRecord = {
  component: () => import('@/views/foreman/ForemanList.vue'),
  name: RouteNames.Foreman.List,
  path: '',
};

export const foremanRoutes: AppRouteRecord = {
  children: [
    //
    foremanEditRoute,
    foremanCreateRoute,
    foremanListRoute,
  ],
  meta: {
    icon: Icons.Foreman,
  },
  path: '/foreman',
};
